if(!customElements.get('product-accordion')) {
  class ProductAccordion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const accordions = this.querySelectorAll('details');

      accordions.forEach((accordion) => {
        accordion.addEventListener("toggle", () => {
          if (accordion.open) {
            /* close all other accordions */
            accordions.forEach((el) => {
              if(el !== accordion) {
                el.removeAttribute('open');
              }
            });

            // Adjust scroll speed if we're coming from a different section
            let scrollBehavior = "instant";
            if (accordion.classList.contains('smooth-scroll')) {
              accordion.classList.remove('smooth-scroll');
              scrollBehavior = "smooth";
            }

            const offsetHeight = document.querySelector('announcement-bar').clientHeight + document.querySelector('header-wrapper').clientHeight;
            window.scrollTo({
              top: document.querySelector('.product__bottom product-accordion').offsetTop - offsetHeight,
              left: 0,
              behavior: scrollBehavior
            })
          }
        });
      });
    }
  }

  customElements.define('product-accordion', ProductAccordion)
}